<template>
  <div class="resource-delivery">
    <div class="title-en">搜索条件</div>
    <el-card class="box-card">
      <div class="search-container">
        <el-form :inline="true" :model="searchForm" class="search-form" label-width="130px">
          <el-row :gutter="20">
            <el-col :span="6">
              <el-form-item label="月份">
                <el-date-picker v-model="searchForm.Month" type="month" placeholder="请选择月份" format="yyyy-MM"
                  value-format="yyyy-MM" clearable>
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="订单号">
                <el-input v-model="searchForm.orderNo" placeholder="请输入订单号"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="工单号">
                <el-input v-model="searchForm.ticketId" placeholder="请输入工单号"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="一级机房">
                <el-input v-model="searchForm.idcpName" placeholder="请输入一级机房"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="6">
              <div class="search-button">
                <el-button type="primary" @click="handleSearch">点击查询</el-button>
                <el-button @click="handleReset">重置</el-button>
                <el-button @click="debouncedExport">{{ exportButtonText }}</el-button>
              </div>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </el-card>
    <div class="title-en">TPC账单列表</div>

    <el-card class="box-card">
      <div class="table-container">
        <div class="button-container">
          <el-button @click="openColumnsDialog">表头设置</el-button>
        </div>
        <el-table :data="faults" border stripe @selection-change="handleSelectionChange" ref="table"
          v-loading="loading">
          <el-table-column type="selection" width="55" align="center"></el-table-column>
          <el-table-column v-for="(column, index) in visibleColumns" :key="index" :prop="column.prop"
            :label="column.label" :width="column.width" :header-style="{
              'white-space': 'normal',
              'word-break': 'break-all',
              height: 'auto',
              'line-height': '1.2',
              padding: '8px 0',
            }" show-overflow-tooltip>
            <template slot-scope="scope">
              <span v-if="column.prop === 'num'">{{ scope.row.num || 0 }}</span>
              <span v-else-if="column.prop === 'realNum'">{{ scope.row.realNum || 0 }}</span>
              <el-tag v-else-if="column.prop === 'billType'" :type="scope.row.billType === '1' || scope.row.billType === 1
                ? 'success'
                : scope.row.billType === '2' || scope.row.billType === 2
                  ? 'warning'
                  : scope.row.billType === '0' || scope.row.billType === 0
                    ? 'info'
                    : 'danger'
                " size="small">
                {{
                  scope.row.billType === '1' || scope.row.billType === 1
                    ? '全额计费'
                    : scope.row.billType === '2' || scope.row.billType === 2
                      ? '打折计费'
                      : scope.row.billType === '0' || scope.row.billType === 0
                        ? '不计费'
                        : '-'
                }}
              </el-tag>
              <el-tag v-else-if="column.prop === 'status'" :type="scope.row.status === '已完成'
                ? 'success'
                : scope.row.status === '进行中'
                  ? 'warning'
                  : 'info'
                " size="small">
                {{ scope.row.status || '-' }}
              </el-tag>
              <span v-else-if="column.prop === 'endTime' || column.prop === 'startTime' || column.prop === 'olaTime'">{{
                scope.row[column.prop]
                  ? $moment(scope.row[column.prop]).format('YYYY-MM-DD HH:mm:ss')
                  : '-'
              }}</span>
              <span v-else-if="column.prop === 'opTicketid'">
                <a :href="scope.row.feedback_status === '已收单'
                  ? `https://dcops.fre.tencent-cloud.com/operateManage/business/ToDoDetails?params=${scope.row.opTicketid}&isHistory=1`
                  : `https://dcops.fre.tencent-cloud.com/operateManage/business/ToDoDetails?params=${scope.row.opTicketid}&isHistory=1`
                  " target="_blank">{{ scope.row.opTicketid }}</a>
              </span>
              <span v-else-if="column.prop === 'isActive'">{{
                scope.row.isActive === 1 || scope.row.isActive === '1'
                  ? '是'
                  : scope.row.isActive === 0 || scope.row.isActive === '0'
                    ? '否'
                    : '-'
              }}</span>
              <span v-else>{{ scope.row[column.prop] || '-' }}</span>
            </template>
          </el-table-column>
        </el-table>

        <el-dialog title="设置显示项" :visible.sync="showColumnsDialog" :append-to-body="true" width="600px"
          :close-on-click-modal="false" custom-class="columns-dialog" :modal-append-to-body="false"
          :destroy-on-close="true">
          <el-checkbox-group v-model="selectedColumns" class="checkbox-group">
            <el-checkbox v-for="column in columns" :key="column.prop" :label="column.prop" class="checkbox-item">
              {{ column.label }}
            </el-checkbox>
          </el-checkbox-group>
          <div slot="footer" class="dialog-footer">
            <el-button size="small" @click="selectAllColumns">全选</el-button>
            <el-button size="small" @click="restoreDefaultColumns">恢复默认</el-button>
            <el-button size="small" type="primary" @click="saveColumnsDialog">保存</el-button>
          </div>
        </el-dialog>

        <div class="pagination-container">
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
            :current-page="currentPage" :page-sizes="[10, 20, 30, 50]" :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper" :total="total" />
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
import { serviceBillList } from '@/api/appManage';
import { getMachineList } from '@/api/workOrder';
import * as XLSX from 'xlsx';
import { debounce } from 'lodash';
export default {
  name: 'ResourceDelivery',
  data() {
    // 获取上个月的年月格式
    const lastMonth = new Date();
    lastMonth.setMonth(lastMonth.getMonth() - 1);
    const lastMonthStr = lastMonth.getFullYear() + '-' + String(lastMonth.getMonth() + 1).padStart(2, '0');

    return {
      debouncedExport: null,
      faults: [],
      searchForm: {
        Month: lastMonthStr,
        orderNo: '',
        ticketId: '',
        idcpName: '',
        page: 1,
        size: 10,
      },

      currentPage: 1,
      pageSize: 10,
      total: 0,
      showColumnsDialog: false,
      selectedColumns: [
        'ticketId',
        'svrItem',
        'billType',
        'completer',
        'idcpName',
        'checkReason',
        'Month',
        'orderNo'
      ],
      defaultSelectedColumns: [
        'ticketId',
        'svrItem',
        'billType',
        'completer',
        'idcpName',
        'checkReason',
        'Month',
        'orderNo'
      ],
      columns: [
        { prop: 'ticketId', label: 'Dcops单号(工作工单号)', width: 250 },
        { prop: 'svrItem', label: '结费项', width: 180 },
        { prop: 'billType', label: '计费系数', width: 100 },
        { prop: 'completer', label: '结单人', width: 100 },
        { prop: 'idcpName', label: '一级机房', width: 120 },
        { prop: 'checkReason', label: '审核原因结果', width: 480 },
        { prop: 'Month', label: '所属计费月份', width: 100 },
        { prop: 'orderNo', label: '订单号'},

        { prop: 'opTicketid', label: '关联主单id', width: 130 },

        { prop: 'campusName', label: '园区', width: 100 },
        { prop: 'ticketType', label: '工单类型', width: 120 },
        { prop: 'ticketScene', label: '工单场景', width: 100 },
        { prop: 'startTime', label: '工单派单时间', width: 150 },
        { prop: 'endTime', label: '工单结单时间', width: 150 },
        { prop: 'olaTime', label: '超时时间', width: 150 },
        { prop: 'isLate', label: '是否超时', width: 80 },
        { prop: 'lateReason', label: '超时原因', width: 120 },
        { prop: 'isFMCCheck', label: '是否人工审核', width: 80 },
        { prop: 'serviceName', label: '服务商', width: 80 },
        { prop: 'poServiceConfirmNo', label: 'PO确认工单号（服务商）', width: 150 },
        { prop: 'poCostNo', label: 'PO计费工单号（服务商）', width: 120 },
        { prop: 'billStatus', label: '正常计费/不计费/打折计费', width: 100 },
        { prop: 'isActive', label: '是否有效计费', width: 80 },
      ],
      visibleColumns: [],
      selectedRows: [],
      machineList: [],
      loading: false,
    };
  },
  created() {
    this.visibleColumns = this.columns.filter((column) =>
      this.selectedColumns.includes(column.prop)
    );
    this.fetchFaultData();
    // 创建防抖后的导出函数
    this.debouncedExport = debounce(this.handleExport, 300);
  },
  methods: {
    async fetchFaultData() {
      const params = {
        Month: this.searchForm.Month,
        orderNo: this.searchForm.orderNo,
        ticketId: this.searchForm.ticketId,
        idcpName: this.searchForm.idcpName,
        billBigType: "TPC",
        page: this.currentPage,
        size: this.pageSize,
      };
      // 过滤掉空值
      Object.keys(params).forEach((key) => {
        if (params[key] === '' || params[key] === null || params[key] === undefined) {
          delete params[key];
        }
      });

      this.loading = true;

      try {
        // 使用serverFaultBillAppendixList接口进行查询
        const response = await serviceBillList(params);
        console.log('======', response);

        if (response.data) {
          let filteredData = response.data.data || [];
          this.faults = filteredData;
          this.total = response.data.total || 0;
        }
      } catch (error) {
        console.error('请求错误:', error);
        let errorMessage = '获取数据失败';
        if (error.response && error.response.status === 422) {
          errorMessage = '请求参数格式不正确，请检查输入';
        }
        this.$message.error(errorMessage);
      } finally {
        this.loading = false;
      }
    },
    handleSearch() {
      this.currentPage = 1;
      this.fetchFaultData();
    },
    handleReset() {
      // 获取上个月的年月格式
      const lastMonth = new Date();
      lastMonth.setMonth(lastMonth.getMonth() - 1);
      const lastMonthStr = lastMonth.getFullYear() + '-' + String(lastMonth.getMonth() + 1).padStart(2, '0');

      this.searchForm = {
        Month: lastMonthStr,
        orderNo: '',
        ticketId: '',
        idcpName: '',
        page: 1,
        size: 10,
      };

      this.currentPage = 1;
      this.fetchFaultData();
    },
    openColumnsDialog() {
      this.showColumnsDialog = true;
    },
    saveColumnsDialog() {
      this.showColumnsDialog = false;
      this.visibleColumns = this.columns.filter((column) =>
        this.selectedColumns.includes(column.prop)
      );
    },
    selectAllColumns() {
      this.selectedColumns = this.columns.map((column) => column.prop);
    },
    restoreDefaultColumns() {
      this.selectedColumns = [...this.defaultSelectedColumns];
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage = 1;
      this.fetchFaultData();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.fetchFaultData();
    },
    handleSelectionChange(selection) {
      this.selectedRows = selection;
    },
    async handleExport() {
      this.exportLoading = true;
      try {
        if (this.selectedRows.length === 0) {
          // 导出全部数据
          this.loading = true;
          const params = {
            Month: this.searchForm.Month,
            orderNo: this.searchForm.orderNo,
            ticketId: this.searchForm.ticketId,
            idcpName: this.searchForm.idcpName,
            billBigType: "TPC",
            export_excel: 1
          };
          // 过滤掉空值
          Object.keys(params).forEach((key) => {
            if (params[key] === '' || params[key] === null || params[key] === undefined) {
              delete params[key];
            }
          });
          const response = await serviceBillList(params);

          if (response.data) {
            this.loading = false;
            const allData = response.data.data || [];
            // 转换数据格式，确保与表格显示一致
            const worksheetData = allData.map((row) => {
              const rowData = {};
              this.visibleColumns.forEach((column) => {
                if (column.prop !== 'operation') {
                  // 排除操作列
                  let value = row[column.prop];
                  // 特殊字段处理，与表格显示保持一致
                  if (
                    column.prop === 'startTime' ||
                    column.prop === 'endTime' ||
                    column.prop === 'createTime'
                  ) {
                    value = row[column.prop]
                      ? this.$moment(row[column.prop]).format('YYYY-MM-DD HH:mm:ss')
                      : '-';
                  }
                  rowData[column.label] = value !== null && value !== undefined ? value : '-';
                }
              });
              return rowData;
            });

            // 创建工作簿和工作表
            const worksheet = XLSX.utils.json_to_sheet(worksheetData);

            // 设置列宽
            const colWidths = {};
            this.visibleColumns.forEach((column, index) => {
              const width = column.width ? Math.ceil(parseInt(column.width) / 7) : 10;
              colWidths[XLSX.utils.encode_col(index)] = { wch: width };
            });
            worksheet['!cols'] = Object.values(colWidths);

            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, 'TPC账单列表');

            // 生成文件名
            const timestamp = this.$moment().format('YYYYMMDDHHmmss');
            const filename = `TPC账单列表_${timestamp}.xlsx`;

            // 导出文件
            XLSX.writeFile(workbook, filename);
            this.$message.success('导出成功');
          }
        } else {
          // 导出选中数据的逻辑保持不变
          const worksheetData = this.selectedRows.map((row) => {
            const rowData = {};
            this.visibleColumns.forEach((column) => {
              if (column.prop !== 'operation') {
                // 排除操作列
                let value = row[column.prop];
                if (column.prop === 'billType') {
                  value =
                    row[column.prop] === '1'
                      ? '全额计费'
                      : row[column.prop] === '2'
                        ? '打折计费'
                        : row[column.prop] === '0'
                          ? '不计费'
                          : '-';
                } else if (column.prop === 'billStatus') {
                  value = row[column.prop] || '-';
                } else if (
                  column.prop === 'startTime' ||
                  column.prop === 'endTime' ||
                  column.prop === 'olaTime'
                ) {
                  value = row[column.prop]
                    ? this.$moment(row[column.prop]).format('YYYY-MM-DD HH:mm:ss')
                    : '-';
                } else if (column.prop === 'isLate' || column.prop === 'isFMCCheck') {
                  value = row[column.prop] || '-';
                } else if (column.prop === 'isActive') {
                  value = row[column.prop] === 1 ? '是' : row[column.prop] === 0 ? '否' : '-';
                }
                rowData[column.label] = value !== null && value !== undefined ? value : '-';
              }
            });
            return rowData;
          });

          const worksheet = XLSX.utils.json_to_sheet(worksheetData);

          const colWidths = {};
          this.visibleColumns.forEach((column, index) => {
            const width = column.width ? Math.ceil(parseInt(column.width) / 7) : 10;
            colWidths[XLSX.utils.encode_col(index)] = { wch: width };
          });
          worksheet['!cols'] = Object.values(colWidths);

          const workbook = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(workbook, worksheet, 'TPC账单列表');

          const timestamp = this.$moment().format('YYYYMMDDHHmmss');
          const filename = `TPC账单列表_${timestamp}.xlsx`;

          XLSX.writeFile(workbook, filename);
          this.$message.success('导出成功');
        }
      } catch (error) {
        console.error('导出错误:', error);
        this.$message.error('导出失败，请重试');
      } finally {
        this.exportLoading = false;
        this.loading = false;
      }
    },
  },
  computed: {
    exportButtonText() {
      return this.selectedRows.length > 0 ? `导出已选(${this.selectedRows.length})` : '导出全部';
    },
  },
  watch: {
    selectedColumns(val) {
      this.selectAll = val.length === this.columns.length;
      this.isIndeterminate = val.length > 0 && val.length < this.columns.length;
    },
  },
};
</script>

<style scoped>
.resource-delivery {
  padding: 0;
}

.title {
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 30px;
}

.search-container {
  padding: 20px;
  background-color: #fff;
  border-radius: 4px;
}

.search-form {
  width: 100%;
}

.search-button {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  margin-left: 13px;
}

/* 调整表单项间距 */
.el-form-item {
  margin-bottom: 18px;
  display: flex;
}

.button-container {
  margin-bottom: 20px;
  display: flex;
  justify-content: flex-end;
  position: relative;
}

.box-card {
  margin-bottom: 20px;
}

.pagination-container {
  display: flex;
  justify-content: flex-end;
}

.title-en {
  margin: 10px 0;
  padding-left: 10px;
  border-left: 3px solid #219aff;
  font-weight: normal;
}

.columns-dialog {
  margin-top: 0 !important;
  position: absolute !important;
  margin-left: 0 !important;
  top: 100% !important;
  left: 0 !important;
  transform: none !important;
}

.el-dialog__wrapper.columns-dialog {
  position: absolute !important;
  overflow: visible !important;
}

.button-container {
  margin-bottom: 20px;
  display: flex;
  justify-content: flex-end;
  position: relative;
}

.checkbox-group {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
  padding: 10px;
  max-height: 300px;
  overflow-y: auto;
}

.checkbox-item {
  margin-right: 0;
  white-space: normal;
  word-break: break-all;
  line-height: 1.2;
  padding: 5px 0;
}

.dialog-footer {
  text-align: right;
  padding-top: 15px;
  border-top: 1px solid #ebeef5;
}

.dialog-footer .el-button+.el-button {
  margin-left: 8px;
}

/* 修改日期选择器宽度 */
::v-deep .el-date-editor.el-input__inner,
.el-date-editor--daterange.el-input__inner {
  width: 100% !important;
}

::v-deep .el-range-editor.el-input__inner {
  width: 100% !important;
}

::v-deep .el-date-editor .el-range-input {
  width: 66% !important;
}

::v-deep .el-range-editor--small .el-range-input {
  font-size: 12px !important;
}

/* 统一下拉框和输入框宽度 */
::v-deep .el-select,
.el-input {
  width: 100% !important;
}

::v-deep .el-form-item__content {
  width: calc(100% - 10px) !important;
}

/* PO单号链接样式 */
::v-deep .el-table a {
  color: #409eff;
  text-decoration: none;
  font-weight: 500;
}

::v-deep .el-table a:hover {
  color: #66b1ff;
  text-decoration: underline;
  font-weight: 500;
}
</style>
